import { Injectable } from '@angular/core';
import { IBrowserStore } from './browser.types';

@Injectable({ providedIn: 'root' })
export class BrowserStore implements IBrowserStore {
  getInjectedOnWindow<T extends typeof window>(field: string): T | null {
    return window?.[field as never] as T;
  }
}
